import { ContextMenuConstants } from "../redux_constants/context.menu.constant"

export const makeMenuVisible = (popupProps) => ({
    type : ContextMenuConstants.MAKE_MENU_VISIBLE, 
    popupProps: popupProps,
})

export const makeMenuInvisible = () => ({
    type : ContextMenuConstants.MAKE_MENU_INVISIBLE, 
})